import { Component } from '@angular/core';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { ActionMode } from '../../../../shared/store/view/types';
import { ButtonType } from '../../../../shared/store/subheader/type';

@Component({
  selector: 'app-contract-create-subheader',
  standalone: false,
  templateUrl: './contract-create-subheader.component.html',
  styleUrl: './contract-create-subheader.component.scss',
})
export class ContractCreateSubheaderComponent {
  constructor(private readonly subHeaderService: SubHeaderService) {}

  ngOnInit(): void {}

  triggerAction(actionName) {
    this.subHeaderService.setTriggerAction(actionName);
  }

  protected readonly ActionMode = ActionMode;
  protected readonly ButtonType = ButtonType;
}
